import React, { Component, Suspense } from 'react';
import { Card, Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCheck, faPen, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment';
import { CodingEventService } from '../../../services';
import { CodingEventTable } from '../../../controls/';

class GroupQueue extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filters: {
                accountId: 0,
                assignedToId: 0,
                queueId: 0,
                statusId: 0,
                take: 0,
                skip: 0,
                showCustomerQueue: false,
                showTeamQueue: false,
                showMyQueue: false,
                fetchRefData: true,
            }
        };
    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto" >Coding Events</div>
                    <div className="card-btn-group">
                    </div>
                </Card.Header>
                <Card.Body className="card-body-table">
                    <CodingEventTable filters={this.state.filters} />
                </Card.Body>
            </Card>
        );
    }

}

export default GroupQueue;